export default __webpack_public_path__ + "static/media/g02.6155e4f9.gif";